import fetch from './fetch'

/**
 * 获取当前用户的所有书籍
 */
export function fetchAllBook() {
	return fetch({
		url: '/books/list',
		method: 'get'
	})
}


/**
 * 保存新建作品
 * @param data 书籍参数
 */
export function addBook(data) {
	return fetch({
		url: `/books`,
		method: 'post',
		data
	})
}


/*
* 获取作品分类
* */
export function fetchCategory_api() {
	return fetch({
		url: `/bookcategory/tree`,
		method: 'get'
	})
}


/**
 * 获取作品信息
 * @param id 书籍id
 */
export function getBookInfo_api(id) {
	return fetch({
		url: `/books/${id}`,
		method: 'get'
	})
}

//删除作品
export function deleteBook_api(id) {
	return fetch({
		url: `/books/${id}`,
		method: 'delete',
		data:{}
	})
}

/**
 * 修改作品信息
 * @param id 书籍id
 * @param data 作品参数
 */
export function updateBookInfo_api({id, data}) {
	return fetch({
		url: `/books/${id}`,
		method: 'put',
		data
	})
}

/**
 * 修改作品封面
 * @param id    作品ID
 * @param data 参数
 */
export function updateBookCover_api({id, data}) {
	return fetch({
		url: `/books/${id}/img`,
		method: 'put',
		data
	})
}

/*注册作家校验笔名*/
export function checkBookName(data) {
	return fetch({
		url: `/books/check/book/name`,
		method: 'post',
		data
	})
}

/*获取作品更新信息*/
export function getBookUpdateInfo_api(data) {
	return fetch({
		url: '/days/words',
		method: 'get',
		params: data
	})
}

export function applyFinish_api(bookId) {
	return fetch({
		url: `/benefit/book/${bookId}/finish/apply`,
		method: 'put'
	})
}

//查询作家CP的作品标签
export function fetchTags() {
	return fetch({
		url: '/tags',
		method: 'get'
	})
}

//显示黄金联赛类型
export function fetchGoldCompetitionTypes() {
	return fetch({
		url: '/golden/types',
		method: 'get'
	})
}

//保存黄金联赛参赛
export function attendGoldCompetition(data) {
	return fetch({
		url: '/golden/competitions',
		method: 'post',
		data
	})
}

// 根据作品ID查询合同信息（仅限申请签约合同）
export function fetchBookSign(bookId) {
	return fetch({
		url: `/e_contract/book_sign/${bookId}`,
		method: 'get',
	})
}



// WEBPACK FOOTER //
// ./src/api/bookManage.js